import { EVENTS } from '../../constants/events/events.constant'

/**
 * @file Defines the {@link Click} class
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /** Class for handling adding event handlers */
 export class Click {

    /**
     * Attach click event handler to an element
     * @param {HTMLElement}   elem_   - Reference to HTML element
     * @param {function}      click_  - Callback function reference
     * @param {object}        this_   - Reference to class's scope
     * @param {*}             params_ - Optional params to be used in callback function
     */
    constructor(elem_, click_, this_, params_ = null) {

        let handler = ((e_) => {

            //If touch event
            if(e_.type === 'touchstart') {
                e_.preventDefault() //Prevent click event firing as well as touch
            }

            click_(this_, params_) //Execute click callback

        })

        //For each event
        EVENTS.forEach((e_) => {
            elem_.addEventListener(e_, handler) //Add handler event
        })

    }

 }